import Logger from 'core/utils/Logger'

export declare interface IPromotion {
  type: string
  promotionTypeLocalName: string
  promotionName: string
  dealBeginDate: string
  dealEndDate: string
  linkToProgramStart: string
  promotionDescription: string
  linkToTerms: string
}

export declare interface IBPHotPromotion {
  rewardAmount: number
  rewardCurrency: string
  productLine: string
  dealBeginDate: string
  dealEndDate: string
}

interface IPartnerPromotionItem {
  Product_Desc: string
  Product_Num: string
  Product_Quantity: number
}

export declare interface IPartnerPromotion {
  dealNum: string
  dealVersion: string
  mcChargeCd: string
  alphcode: string
  description: string
  dealDescription: string
  productNumOrBundleId: string
  isBundle: string
  dealBeginDate: string
  dealEndDate: string
  indicativeBuyingPrice: string
  currency: string
  items: IPartnerPromotionItem[]
}

export declare interface IProductProperty {
  name: string
  value: string
}

const initialData = {
  productType: 0,
  image: '',
  listPrice: 0,
  obsoleteDate: '',
  name: '',
  number: '',
  stock: false,
  promotions: {
    partner: [] as IPartnerPromotion[],
    user: [] as IPromotion[],
    bpHotOffers: [] as IBPHotPromotion[],
  },
  properties: [] as IProductProperty[],
}

export type TModel = typeof initialData

const stringToJson = (s: string): IPartnerPromotionItem[] => {
  let result: IPartnerPromotionItem[] = []

  const prepareJsonString = (s: string): string => {
    // @ts-ignore
    return s
      .replace(/\n/g, '')
      .replace(/\t/g, '')
      .replace(/'/g, '"')
      .replace(new RegExp(/[\u0000-\u0019]+/, 'g'), '')
      .replace(/"(?=[^<]*>)/g, '\\"')
  }
  try {
    result = JSON.parse(prepareJsonString(s))
  } catch (e) {
    Logger.error(e)
  }
  return result
}

export const create = (data?: Partial<TModel>): TModel => ({
  ...initialData,
  ...data,
})

export const map = (data: IObjectAny): TModel => {
  const productInfo = data.productInfo
  return {
    ...initialData,
    image: (productInfo && productInfo.ProductImage) || initialData.image,
    listPrice: (productInfo && parseFloat(productInfo.ListPrice)) || initialData.listPrice,
    obsoleteDate: (productInfo && productInfo.ObsoleteDate) || initialData.obsoleteDate,
    name: (productInfo && productInfo.ProductName) || initialData.name,
    number: (productInfo && productInfo.ProductNumber) || initialData.number,
    stock: productInfo && !!productInfo.Stocks,
    promotions: {
      partner:
        (data.partner &&
          data.partner.map((i: any) => {
            return { ...i, items: stringToJson(i.items) }
          })) ||
        [],
      user: (data.user && data.user.map((i: any) => ({ ...i }))) || [],
      bpHotOffers: (data.bpHotOffers && data.bpHotOffers.map((i: any) => ({ ...i }))) || [],
    },
    properties:
      (productInfo &&
        productInfo.TechInfo &&
        productInfo.TechInfo.sort(orderSort).map((i: any) => {
          return {
            name: i['EnglishName'],
            value: i['value'],
          }
        })) ||
      [],
  }
}

const orderSort = (a: any, b: any) => {
  if (a['Order'] < b['Order']) {
    return -1
  }
  if (a['Order'] > b['Order']) {
    return 1
  }
  return 0
}
